import React, { useContext, useState, useEffect } from 'react';

import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { CloseRounded } from '@mui/icons-material';
import { Button, CircularProgress } from '@mui/material';

const DeleteCompanyModal = ({modalDetails, onOptimisticDelete}) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);

  const [isDeleting, setIsDeleting] = useState(false);

  const closeHandle = () => {
    modalCtx.closeModal();
  }

  const deleteCompany = () => {

    setIsDeleting(true);

    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/company/${modalDetails.id}/remove`,
      {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${authCtx.token}`  
        }
      }
    )
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        if(onOptimisticDelete){
          onOptimisticDelete(modalDetails.id);
        }
        modalCtx.closeModal();
        modalCtx.setPageUpdate({ page: "Companies", companyId: modalDetails.id });
      } else {
        console.error("Error deleting company:", data);
      }
      setIsDeleting(false);
    })
    .catch(error => {
      console.error("Error deleting company:", error);
      setIsDeleting(false);
    })
  }

  return (
    <>
      <div className="modal-container">
        <div className='modal-header'>
          <h1>Delete Company<br/><span className='company-name'>{modalDetails.companyDetails.company}</span></h1>
        </div>
        <div className="modal-body">
          <span>Are you sure you want to delete this company?</span><br/>
          <span style={{fontSize: "12px", color: "#555"}}>Doing so will mark this company as deleted and you will have 30 days to restore it.</span>
        </div>
        <div className="modal-footer">
          <Button className="cancel-btn" onClick={closeHandle} disabled={isDeleting}>CANCEL</Button>
          <Button onClick={() => deleteCompany()} disabled={isDeleting}>{isDeleting ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ""} DELETE</Button>
        </div>
      </div>
    </>
  )
}

export default DeleteCompanyModal;
